/*
  Careers form behaviour (sections/dn-employment-form.liquid).

  Two things the markup cannot express on its own:

  1. The "Are you 16 or older?" follow-up, shown only when the applicant answers
     No to "Are you 18 or older?". Its wrapper is aria-live="polite", so removing
     `hidden` announces the new question rather than only revealing it visually.
     `required` is added and removed alongside, because a hidden required radio
     makes the form unsubmittable on a control nobody can see or focus.

  2. "When can you work?" is at-least-one-of-three. Native `required` on a
     checkbox means *that* box must be ticked, so the rule is enforced here and
     reported through the group's own error span.

  The submit listener is registered in the capture phase so it runs before the
  Formspree AJAX handler bound on the same form, and stops the submission there
  when the group is empty.
*/
(function () {
  'use strict';

  var form = document.getElementById('dn-apply-form');
  if (!form) return;

  // --- Conditional age follow-up ---

  var age16Group = document.getElementById('dn-apply-age16-group');
  var age18Radios = form.querySelectorAll('[data-dn-age18]');
  var age16Radios = form.querySelectorAll('[data-dn-age16]');
  var age16Error = document.getElementById('dn-apply-age16-error');

  function syncAgeFollowUp() {
    if (!age16Group) return;

    var answeredNo = false;
    age18Radios.forEach(function (radio) {
      if (radio.checked && radio.value === 'No') answeredNo = true;
    });

    if (answeredNo) {
      age16Group.hidden = false;
      age16Radios.forEach(function (radio) {
        radio.required = true;
        radio.setAttribute('aria-required', 'true');
      });
    } else {
      age16Group.hidden = true;
      age16Radios.forEach(function (radio) {
        radio.required = false;
        radio.removeAttribute('aria-required');
        radio.checked = false;
      });
      if (age16Error) age16Error.textContent = '';
    }
  }

  age18Radios.forEach(function (radio) {
    radio.addEventListener('change', syncAgeFollowUp);
  });

  // Run once on load: a back-navigation or autofill can restore a checked "No"
  // without ever firing a change event.
  syncAgeFollowUp();

  // --- At-least-one checkbox group ---

  var checkboxGroups = form.querySelectorAll('[data-dn-checkbox-group]');

  function groupBoxes(group) {
    return group.querySelectorAll('input[type="checkbox"]');
  }

  function groupError(group) {
    return group.querySelector('.dn-apply__field-error');
  }

  function groupIsSatisfied(group) {
    var satisfied = false;
    groupBoxes(group).forEach(function (box) {
      if (box.checked) satisfied = true;
    });
    return satisfied;
  }

  function clearGroupError(group) {
    var error = groupError(group);
    if (error) error.textContent = '';
    group.removeAttribute('aria-invalid');
  }

  checkboxGroups.forEach(function (group) {
    groupBoxes(group).forEach(function (box) {
      box.addEventListener('change', function () {
        if (groupIsSatisfied(group)) clearGroupError(group);
      });
    });
  });

  form.addEventListener(
    'submit',
    function (event) {
      var firstUnsatisfied = null;

      checkboxGroups.forEach(function (group) {
        if (groupIsSatisfied(group)) {
          clearGroupError(group);
          return;
        }
        var error = groupError(group);
        if (error) error.textContent = 'Choose at least one option.';
        group.setAttribute('aria-invalid', 'true');
        if (!firstUnsatisfied) firstUnsatisfied = group;
      });

      if (firstUnsatisfied) {
        event.preventDefault();
        event.stopPropagation();
        var firstBox = groupBoxes(firstUnsatisfied)[0];
        if (firstBox) firstBox.focus();
      }
    },
    true
  );
})();
